export default __webpack_public_path__ + "0647b46e26c06fb516945b9aba14910e.svg";